module.exports = __webpack_public_path__ + "img/gauge.2837a9af.png";